/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("copyButton")?.addEventListener("click", function(e) {
       e.preventDefault();
        // Copy the code
        var code = document.getElementById("copyButton").getAttribute("data-code");
        copyToClipboard(code);
        this.textContent = "Copied!";
    });
    
    function copyToClipboard(text) {
        var tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = text;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
    }
});

document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("copyButton2")?.addEventListener("click", function(e) {
      //alert("copyButton2");
       e.preventDefault();
        // Copy the code
        var code = document.getElementById("copyButton2").getAttribute("data-code");
        copyToClipboard(code);
     // this.textContent = "Copied!";
    });
    
    function copyToClipboard(text) {
        var tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = text;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
    }

});

 // document.addEventListener('bundler:bundle_widget_created', function(e) {
 //        // e.detail will contain the following JSON object:
 //        // {
 //        // 		products: products,	// Contains products in the bundle which the bundle widget represents
 //        // }
 //   console.log(e.detail.products.length);
 //    });